import { ReactComponent as SearchIcon } from 'assets/img/icon-search-black.svg';
import { components } from 'react-select';
import { useEffect, useRef } from 'react';

const CountriesMenuSearchTemplate = (props) => {
  const { selectProps } = props;
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <components.Menu {...props}>
      <div className="select__option-search">
        <input
          ref={inputRef}
          className="select__option-search-input"
          type="text"
          value={selectProps.search}
          onChange={(e) => selectProps.setSearch(e.target.value)}
          placeholder={selectProps.searchPlaceholder}
          onMouseDown={(e) => e.stopPropagation()}
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
        />
        <SearchIcon className="select__option-search-img" />
      </div>

      {props.children}
    </components.Menu>
  );
};

export default CountriesMenuSearchTemplate;
